import React, { useMemo } from 'react';
import DataTable from '../Components/DataTable';
import FormattedDate from '../Components/FormattedDate';

function TablaUsuarios({ loading, error, onRetry, emptyStateNoReload, pageSize, currentPage, onPageChange, usuarios = [], ...props }) {
    // Memoize columns definition to prevent re-renders (rerender-memo pattern)
    const columns = useMemo(() => [
        {
            Header: 'ID',
            accessor: 'IdUsuario',
        },
        {
            Header: 'Nombre',
            accessor: 'Nombres',
        },
        {
            Header: 'Apellidos',
            accessor: 'Apellidos',
        },
        {
            Header: 'Email',
            accessor: 'Email',
            Cell: ({ value }) => (
                <a href={`mailto:${value}`} style={{ color: 'var(--color-primary, #00c0eb)' }}>
                    {value}
                </a>
            )
        }
    ], []); // Empty dependency array means columns never change

    const getDefaultUsuarios = () => [
        {
            IdUsuario: 1,
            Nombres: "Juan",
            Apellidos: "Pérez García",
            Email: "juan.perez@email.com",
            Registro: "2026-01-30"
        }
    ];

    return (
        <DataTable
            data={(usuarios && usuarios.length > 0) ? usuarios : getDefaultUsuarios()}
            columns={columns}
            idField="IdUsuario"
            selectable={false}
            loading={loading}
            error={error}
            onRetry={onRetry}
            emptyStateNoReload={emptyStateNoReload}
            emptyMessage="No hay usuarios registrados"
            className="tabla-usuarios"
            pageSize={pageSize}
            currentPage={currentPage}
            onPageChange={onPageChange}
        />
    );
}

export default TablaUsuarios;
